import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectTagsListItems } from "../../../../../../redux/tags/selector";
import { tags } from "../../../../../../redux/tags/action";

const ManagementTagsSettings = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const itemsData = useSelector(selectTagsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name' },
    ]);
  }
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const handleEdit = (data: any) => {

    navigate(`${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(tags.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/delete`,
      entity: 'tags',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      dispatch(tags.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/list`,
        entity: 'tags',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  const additionButtons: any = [
    {
      name: 'Add Tags',
      callback: () => handleAdd(),
    }
  ];

  const fetchTagsList = () => {

    dispatch(tags.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/list`,
      entity: 'tags',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc"
      }
    }))
  }
  useEffect(() => {

    createColumnDefs()
    fetchTagsList()
  }, [pageData])


  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
          paginationData={itemsData?.result?.pagination} additionButtons={additionButtons}
          onEdit={handleEdit} onDelete={handleDelete} headingName="Tags" />
      }
    </>
  );
};

export default ManagementTagsSettings;


